import { API_METHODS } from "../../constant";
export const personVisaApi = (
  _getAll,
  _get,
  _update,
  _create,
  _delete,
  paramsIn
) => {
  return {
    [API_METHODS.GET_VISA]: () => {
      let urlReq = `/Person/${paramsIn.PersonId}/Document/Visa/${paramsIn.id}`;
      return _get(urlReq); 
    },
    [API_METHODS.GET_ALL_VISA]: () => {
      let urlReq = `/Person/${paramsIn.PersonId}/Document/Visa`;
      return _getAll(urlReq);  
    },
    [API_METHODS.UPDATE_VISA]: () => {
      let urlReq = `/Person/${paramsIn.PersonId}/Document`;
      return _update(urlReq);
    },
    [API_METHODS.CREATE_VISA]: () => {
      let urlReq = `/Person/${paramsIn.PersonId}/Document`;
      return _create(urlReq); 
    },
    [API_METHODS.DELETE_VISA]: () => {
      let urlReq = `/Person/${paramsIn.PersonId}/Document/${paramsIn.id}`;
      return _delete(urlReq);
    }
  };
};
